import { IMsalContext } from "@azure/msal-react";
import SplashScreen from "Components/SplashScreen";
import React from "react";

const AuthLoading = (props: React.PropsWithChildren<IMsalContext>) => {
  return <SplashScreen />;
};

export default AuthLoading;
